<template>
  <div
    class="container-avaliacao"
    :class="{ 'avaliacao-academy--dark': darkEnabled }"
  >
    <ResultadoAvalicaoAcademy
      :history="history"
      v-if="Object.keys(history).length > 0"
      @resetarProva="resetarProva"
    />

    <div class="avaliacao" v-if="!(Object.keys(history).length > 0)">
      <h2>Avaliação: Atendimento</h2>

      <ul class="pages">
        <li v-for="(_, index) in questoes" :key="index">
          <span :class="{ 'avaliacao-page': true, active: index === pagina }">{{
            index + 1
          }}</span>
        </li>
      </ul>

      <Panel lineColor="var(--primary-color)">
        <div class="container-questao">
          <h4>{{ questoesAtual.questionText }}</h4>

          <ul class="questoes">
            <li
              v-for="(questao, index) in embaralharArray"
              :key="questao.index"
            >
              <input
                type="radio"
                :id="'option-' + pagina + '-' + questao.index"
                :value="questao.index"
                v-model="respostasSelecionadas[pagina]"
              />
              <label :for="'option-' + pagina + '-' + questao.index">
                <span>{{ alfabeto[index] }}</span>
                <p>{{ questao.options }}</p>
              </label>
            </li>
          </ul>
        </div>

        <FormButtonGroup align="end" spaced>
          <FormButton
            text="Voltar"
            type="submissao"
            :rounded="false"
            :disabled="loading"
            @click="paginacao('voltar')"
            v-show="pagina !== 0"
          />
          <FormButton
            :text="adicao ? 'Avançar' : 'Finalizar'"
            type="primario"
            :rounded="false"
            :loading="loading"
            :disabled="loading"
            @click="paginacao('avancar')"
          />
        </FormButtonGroup>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButton from "@/components/form/FormButton";
import ResultadoAvalicaoAcademy from "./ResultadoAvalicaoAcademy.vue";
import { SUBMIT_TEST } from "@/store/actions/academy";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      pagina: 0,
      alfabeto: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
      history: {},
      respostas: [],
      loading: false,
      respostasSelecionadas: {},
      ordemEmbaralhada: {}
    };
  },
  created() {
    this.respostasSelecionadas = {};
    this.ordemEmbaralhada = {};
  },
  components: {
    Panel,
    FormButtonGroup,
    FormButton,
    ResultadoAvalicaoAcademy
  },
  computed: {
    ...mapGetters(["getVideosAcademy", "darkEnabled"]),
    sections() {
      return this.getVideosAcademy || [];
    },
    questoes() {
      const { sectionid } = this.$route.params;
      const sectionAtual =
        this.sections.find(section => section.idSection === sectionid) || {};
      return sectionAtual?.evaluation?.questions || [];
    },
    questoesAtual() {
      return (
        this.questoes[this.pagina] || { selectedOption: null, options: [] }
      );
    },
    embaralharArray() {
      if (!this.ordemEmbaralhada[this.pagina]) {
        const opcao = this.questoesAtual.options.map((option, index) => {
          return { options: option, index: index };
        });

        let array = Array.from(opcao);
        for (let i = array.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }

        this.$set(this.ordemEmbaralhada, this.pagina, array);
      }
      return this.ordemEmbaralhada[this.pagina];
    },
    adicao() {
      return this.pagina + 1 !== this.questoes.length;
    }
  },
  methods: {
    async paginacao(acao) {
      switch (acao) {
        case "voltar":
          this.pagina = this.pagina - 1;
          break;
        case "avancar":
          if (this.adicao) {
            this.pagina = this.pagina + 1;
          } else {
            try {
              const { sectionid } = this.$route.params;
              const respostas = this.questoes.map((_, index) => {
                const key = this.respostasSelecionadas[index];
                return !isNaN(key) ? Number(key) : -1;
              });

              this.loading = true;

              const data = await this.$store.dispatch(SUBMIT_TEST, {
                sectionid: sectionid,
                respostas: { answers: respostas }
              });

              this.history = data;
              this.loading = false;
            } catch (_) {
              this.$vueOnToast.pop("error", "Erro ao submeter respostas");
            }
          }
          break;
        default:
          break;
      }
    },
    resetarProva() {
      this.history = {};
      this.respostasSelecionadas = {};
      this.ordemEmbaralhada = {};
      this.pagina = 0;
    }
  },
  watch: {
    "$route.path": function(valor) {
      if (valor) {
        this.resetarProva();
      }
    }
  }
};
</script>

<style scoped>
li {
  list-style-type: none;
}

h4 {
  color: #696a68;
  text-align: left;
}

ul {
  padding: 0;
}

p {
  margin: 0;
}

.container-avaliacao {
  width: 100%;
  height: calc(100vh - 20px);
  display: flex;
  justify-content: center;
}

.avaliacao {
  width: 70%;
}

.container-avaliacao .avaliacao h2 {
  margin: 1em 0;
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #696a68;
}

.avaliacao-page {
  border-radius: 100px;
  border: solid 1px #dadada;
  padding: 0.5em;
  width: 2.5em;
  height: 2.5em;
  display: flex;
  font-weight: bold;
  background: var(--muted-surface-bg, #f5f5f5);
  color: rgba(0, 0, 0, 0.87);
  transition: all 0.3s ease-in-out;
  align-items: center;
  justify-content: center;
}

.active {
  background: var(--primary-color, #276baf);
  color: white;
  border: solid 3px rgba(0, 0, 0, 0.15);
  transform: scale(1.04);
}

.pages {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}

.container-questao .questoes {
  margin-top: 20px;
}

.container-questao .questoes label {
  display: flex;
  min-height: 70px;
  cursor: pointer;
}

.container-questao .questoes label p:hover {
  background-color: rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}

.container-questao .questoes li {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 20px;
}

.container-questao .questoes span {
  background: var(--primary-color, #00558e);
  color: white;
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 0px 0px 5px;
  font-size: 20px;
  font-weight: bold;
}

.container-questao .questoes p {
  width: 90%;
  display: flex;
  align-items: center;
  text-align: start;
  padding: 8px;
  background: #eee;
  border-bottom: 2px solid #c4c4c4;
  border-radius: 0px 5px 5px 0px;
  color: #464646;
  font-size: 15px;
}

input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + label p {
  background-color: #50b748;
  transition: all 0.3s ease-in-out;
  color: white;
}
</style>

<style lang="scss">
/*
 * Modo escuro: sem scoped + darkEnabled + theme--dark.
 * Indicadores usam --muted-surface-bg no claro; no escuro essa var continua clara no :root,
 * por isso !important e fundo explícito.
 */
.avaliacao-academy--dark .avaliacao h2,
.avaliacao-academy--dark .container-questao h4,
.v-application.theme--dark .container-avaliacao .avaliacao h2,
.v-application.theme--dark .container-avaliacao .container-questao h4 {
  color: rgba(255, 255, 255, 0.87) !important;
}

.avaliacao-academy--dark .avaliacao-page,
.v-application.theme--dark .container-avaliacao .avaliacao-page {
  background: var(--dark-surface, #1d1d1d) !important;
  border-color: rgba(255, 255, 255, 0.22) !important;
  color: rgba(255, 255, 255, 0.87) !important;
}

.avaliacao-academy--dark .avaliacao-page.active,
.v-application.theme--dark .container-avaliacao .avaliacao-page.active {
  background: var(--primary-color) !important;
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
}

.avaliacao-academy--dark .container-questao .questoes label p:hover,
.v-application.theme--dark
  .container-avaliacao
  .container-questao
  .questoes
  label
  p:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.avaliacao-academy--dark .container-questao .questoes p,
.v-application.theme--dark .container-avaliacao .container-questao .questoes p {
  background: #2a2a2a !important;
  border-bottom-color: rgba(255, 255, 255, 0.15) !important;
  color: rgba(255, 255, 255, 0.87) !important;
}

.avaliacao-academy--dark input[type="radio"]:checked + label p,
.v-application.theme--dark
  .container-avaliacao
  input[type="radio"]:checked
  + label
  p {
  background-color: var(--secondary-color, #50b748) !important;
  color: #fff !important;
}
</style>
